import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import { ASK_PHASES } from '../../../../constants/aiAnalytics';
import { AI_COLORS, ASK_PHASE_PROGRESS, PHASE_LABELS } from '../aiAnalyticsConstants';

export default function AskStatusIndicator({ phase, dense = false }) {
  const label = PHASE_LABELS[phase] || 'Working on it…';
  const value = ASK_PHASE_PROGRESS[phase] ?? ASK_PHASE_PROGRESS[ASK_PHASES.PENDING];

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <Typography
        variant={dense ? 'caption' : 'body2'}
        color={dense ? 'text.secondary' : 'text.primary'}
        noWrap={dense}
        title={dense ? label : undefined}
        sx={{ display: 'block', mb: 0.5, ...(dense ? {} : { fontWeight: 600 }) }}
      >
        {label}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height: dense ? 3 : 5,
          borderRadius: 2,
          backgroundColor: AI_COLORS.brandSurface,
          '& .MuiLinearProgress-bar': { backgroundColor: AI_COLORS.brand }
        }}
      />
    </Box>
  );
}
